import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function LubeRollerRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = {target: {value: ""}};

   return (
      <Row className="mb-2">
         <ColPrompt title={"Lube Roller"} bold={true} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.lubeRollerStart || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 100, "lubeRollerStart")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 100, "lubeRollerStart")
               }
            />
            {errorDivDefinitions.lubeRollerStart && <ErrorDiv>0-100 only</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.lubeRollerMax || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 100, "lubeRollerMax")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 100, "lubeRollerMax")
               }
            />
            {errorDivDefinitions.lubeRollerMax && <ErrorDiv>0-100 only</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
